module.exports = __webpack_public_path__ + "img/college-alma.3eecf78b.webp";